module.exports = __webpack_public_path__ + "assets/81113a572b63e5044713c048156864b3.mp3";